import {HttpErrorResponse} from '@angular/common/http';
import {ErrorHandler, Inject, Injectable, Injector} from '@angular/core';
import {Router} from '@angular/router';
import {environment} from '@environment';
import {TranslateService} from '@ngx-translate/core';
import {PortalAuthService} from '@portal-commons/portal-auth.service';
import {ToastrService} from 'ngx-toastr';
import {LoggingService} from './logging.service';

@Injectable()
export class CustomErrorHandlerService extends ErrorHandler {
  private toastService: ToastrService;
  private router: Router;
  private auth: PortalAuthService;
  constructor(
    private loggingService: LoggingService,
    private translateService: TranslateService,
    @Inject(Injector) private readonly injector: Injector,
  ) {
    super();
  }

  handleError(error): void {
    this.toastService = this.injector.get(ToastrService);
    this.router = this.injector.get(Router);
    this.auth = this.injector.get(PortalAuthService);
    if (this.auth?.isAuthenticatedValue() && (!(error instanceof HttpErrorResponse) || (error.status !== 0 && error.status !== 503))) {
      const userInfo = localStorage.getItem('userInfo');
      if (userInfo) {
        const user = JSON.parse(userInfo);
        this.loggingService.error(error, user?.email).subscribe(() => {
          console.log('Logged error');
          console.log(error);
          console.log(' for user: ');
          console.log(user);
        });
      }
    }

    if (!environment.production || error instanceof HttpErrorResponse) {
      let mail = '<a href="mailto:tkg.sck@toyota-fs.com">tkg.sck@toyota-fs.com</a>';
      let phone = '<a href="tel:+49223410210">Tel.: 0 22 34 / 102-10</a>';
      if (this.router.url.includes('onlinedeal')) {
        mail = '<a href="mailto:tfs.digital@toyota-service-center.de">tfs.digital@toyota-service-center.de</a>';
        phone = '<a href="tel:+4922341026700">Tel.: 0 22 34 / 102-67 00</a>';
      }

      let errorText =
        '<br/>Es tut uns leid, leider ist ein technischer Fehler aufgetreten.<br/><br/> Bitte wenden Sie sich an:<br/><br/>' +
        mail +
        '<br/><br/>' +
        phone;
      if (error instanceof HttpErrorResponse && (error.status === 0 || error.status === 503)) {
        errorText = '<br/>' + this.translateService.instant('login.loginForm.loginUnavailable') + '<br/><br/>';
      }
      this.toastService.error(errorText, 'Technischer Fehler', {
        disableTimeOut: true,
        enableHtml: true,
        positionClass: 'toast-center-center',
        toastClass: 'ngx-toastr toastr-min-width',
      });
    }
  }
}
